
import { Component, Vue } from 'vue-property-decorator';
import Alert from '~/components/Alerts/Alert.vue';
import OneTimePayment from '@/components/Payments/OneTimePayment.vue';
import PaymentSettings from '@/components/Payments/PaymentSettings.vue';
import Transactions from '@/components/Transactions/Transactions.vue';
import LoanDetails from '@/components/Loans/LoanDetails.vue';
import ResponsiveContainer from '@/components/Layout/ResponsiveContainer.vue';
import { AvailableLoan } from '@/interfaces/loan';

@Component({
  components: {
    Alert,
    OneTimePayment,
    PaymentSettings,
    ResponsiveContainer,
    Transactions,
    LoanDetails
  }
})
export default class HomeView extends Vue {
  created() {
    if (this.availableLoans.length === 0) {
      this.$store.dispatch('User/fetchUserInfo');
    }
  }

  get availableLoans() {
    return this.$store.getters['User/availableLoans'];
  }

  get activeLoan() {
    const loanNumber = this.$store.getters['User/activeLoanNumber'];
    return this.availableLoans.find((item: AvailableLoan) => {
      return item.loan_number === loanNumber;
    });
  }

  get accountLastFour() {
    return this.$store.getters['Account/getBankAccountLastFour'];
  }
}
